import { render, staticRenderFns } from "./DisplayCurrencyValue.vue?vue&type=template&id=609e0890&"
import script from "./DisplayCurrencyValue.vue?vue&type=script&lang=js&"
export * from "./DisplayCurrencyValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports